const black = '#111';
const green = 'rgba(39, 174, 96, 1)';
const yellow = 'rgba(245, 166, 35, 1)';
const red = 'rgba(241, 91, 87, 1)';

export default {
  _: black,
  DRAFT: yellow,
  DECLINED: red,
  NEW: green,
  CREATED: green,
  APPROVED: green,
  CONFIRMED: green,
  PAID: green,
  ACTIVE: green,
  PAYING: green,
  PROCESSING: green,
  PENDING_PAYMENT: yellow,
  RENEWING: yellow,
  CANCELED: red,
  CANCELLED: red,
  FINAL_PAYMENT_ATTEMPT_FAILED: red,
  PAYMENT_FAILED: yellow,
  PENDING_APPROVAL: yellow,
  APPROVAL_DECLINED: red,
  DISCONTINUED: red,
  PENDING_CANCEL: yellow,
  SUCCESS: green
};
